/// <reference types="./display_time.d.mts" />
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $duration from "../../../gleam_time/gleam/time/duration.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $html from "../../../lustre/lustre/element/html.mjs";
import * as $s from "../../ds/internals/styles/time.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";
import { set_interval, uuid, update_display } from "./timeout.ffi.ts";

class Model extends $CustomType {
  constructor(value, now, target) {
    super();
    this.value = value;
    this.now = now;
    this.target = target;
  }
}

function init_model(value) {
  return new Model(value, $timestamp.system_time(), uuid());
}

function display_date(date, now) {
  let difference = $timestamp.difference(date, now);
  let _block;
  let _pipe = difference;
  let _pipe$1 = $duration.to_seconds(_pipe);
  _block = $float.round(_pipe$1);
  let seconds = _block;
  let _block$1;
  let _pipe$2 = seconds;
  let _pipe$3 = $int.divide(_pipe$2, 60);
  _block$1 = $result.unwrap(_pipe$3, 0);
  let minutes = _block$1;
  let _block$2;
  let _pipe$4 = minutes;
  let _pipe$5 = $int.divide(_pipe$4, 60);
  _block$2 = $result.unwrap(_pipe$5, 0);
  let hours = _block$2;
  let _block$3;
  let _pipe$6 = hours;
  let _pipe$7 = $int.divide(_pipe$6, 24);
  _block$3 = $result.unwrap(_pipe$7, 0);
  let days = _block$3;
  let days$1 = days;
  if (days$1 === 1) {
    return (() => {
      let _pipe$8 = days$1;
      return $int.to_string(_pipe$8);
    })() + " day ago";
  } else {
    let days$2 = days;
    if (days$2 > 0) {
      return (() => {
        let _pipe$8 = days$2;
        return $int.to_string(_pipe$8);
      })() + " days ago";
    } else {
      let hours$1 = hours;
      if (hours$1 === 1) {
        return (() => {
          let _pipe$8 = hours$1;
          return $int.to_string(_pipe$8);
        })() + " hour ago";
      } else {
        let hours$2 = hours;
        if (hours$2 > 0) {
          return (() => {
            let _pipe$8 = hours$2;
            return $int.to_string(_pipe$8);
          })() + " hours ago";
        } else {
          let minutes$1 = minutes;
          if (minutes$1 === 1) {
            return (() => {
              let _pipe$8 = minutes$1;
              return $int.to_string(_pipe$8);
            })() + " minute ago";
          } else {
            let minutes$2 = minutes;
            if (minutes$2 > 0) {
              return (() => {
                let _pipe$8 = minutes$2;
                return $int.to_string(_pipe$8);
              })() + " minutes ago";
            } else {
              let seconds$1 = seconds;
              if (seconds$1 > 10) {
                return (() => {
                  let _pipe$8 = seconds$1;
                  return $int.to_string(_pipe$8);
                })() + " seconds ago";
              } else {
                return "now";
              }
            }
          }
        }
      }
    }
  }
}

function view(model) {
  return $s.time_container(
    toList([
      $s.date_display(
        model.target,
        toList([$html.text(display_date(model.value, model.now))]),
      ),
    ]),
  );
}

export function display_time(value) {
  let model = init_model(value);
  set_interval(
    () => {
      return update_display(
        model.target,
        display_date(value, $timestamp.system_time()),
      );
    },
    60_000,
  );
  return view(model);
}
